import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { AccountModal, Spinner } from '../../components'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login';
import Consts from '../../config/constants'

const SignUpModal = ({
    isVisible,
    onCloseModal,
    handleSubmit,
    onSubmit,
    facebookSignUp,
    openSignInModal,
    message,
    loading,
    googleSignUp,
}) => (
    <AccountModal isVisible={isVisible} onCloseModal={() => onCloseModal()}>
        <p className="account-modal-title">Cadastrar</p>
        { message &&
            <div className={`callout ${message.type}`} data-closable>
                <p className="callout-message">{message.message}</p>
            </div>
        }
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <FacebookLogin
                    appId={Consts.FACEBOOK_APP_ID}
                    autoLoad={false}
                    textButton="Entrar com o Facebook"
                    size="small"
                    cssClass="facebook-button"
                    icon={<i className="icon-facebook" />}
                    disableMobileRedirect={true}
                    fields="id,first_name,last_name,email,picture,gender,link,birthday,age_range,location,locale"
                    scope="user_link,user_gender,user_location,user_birthday,user_age_range,email"
                    callback={facebookSignUp}
                />
                <GoogleLogin
                    clientId={Consts.GOOGLE_APP_URL}
                    buttonText="Entrar com o Google"
                    className="google-login"
                    onSuccess={googleSignUp}
                    cookiePolicy={'single_host_origin'}
                />
            </div>
            <div className="account-signin-modal-divider"></div>
            <Field component="input" className="account-modal-input" required name="firstName" placeholder="Nome" type="text" maxLength="150" />
            <Field component="input" className="account-modal-input" required name="lastName" placeholder="Sobrenome" type="text" maxLength="150" />
            <Field component="input" className="account-modal-input" required name="email" placeholder="E-mail" type="email" maxLength="150" />
            <Field component="input" className="account-modal-input" required name="password" placeholder="Senha" type="password" maxLength="150" />
            <Field component="input" className="account-modal-input" required name="confirmPassword" placeholder="Confirmar Senha" type="password" maxLength="150" />
            <button className="account-button" type="submit">Criar conta</button>
            <p className="register-info">
                Ao me cadastrar, concordo com os
                <a href="https://beduka.com/termos-de-uso/" target="_blank" title="Termos de uso" rel="noopener noreferrer"> Termos de uso</a> e
                <a href="https://beduka.com/politica-de-privacidade/" target="_blank" title="Política de privacidade" rel="noopener noreferrer"> Política de privacidade</a> do Beduka.
            </p>
        </form>
        <div className="account-modal-footer">
            <p className="account-modal-footer-info">
                Já possui uma conta? <a onClick={() => openSignInModal()} title="Entrar agora">Entrar agora</a>
            </p>
        </div>
        <Spinner isLoading={ loading } />
    </AccountModal>
);

export default reduxForm({ form: 'signUpForm' })(SignUpModal);
